
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M12.959 3.029c.78.78.78 2.047 0 2.828L7.32 11.496a4 4 0 01-2.232 1.127l-2.029.305h0l.306-2.028a3.996 3.996 0 011.127-2.233L10.13 3.03a2 2 0 012.829 0zM9.595 5.064l2.121 2.122"}})])
          )
        }
      }
    